import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "User not found",
    RO: "Utilizatorul nu a fost găsit",
  },
  no_password: {
    EN: "User does not have a password",
    RO: "Utilizatorul nu are o parolă",
  },
  // to only be used when trying to change password!!
  wrong_password: {
    EN: "Wrong password",
    RO: "Parolă greșită",
  },
  account_not_found: {
    EN: "User or password is incorrect",
    RO: "Utilizator sau parolă incorectă",
  },
  session_not_found: {
    EN: "Session not found",
    RO: "Sesiunea nu a fost găsită",
  },
  session_expired: {
    EN: "Session has expired",
    RO: "Sesiunea a expirat",
  },
  password_required: {
    EN: "Password is required",
    RO: "Parola este necesară",
  },
  user_not_verified: {
    EN: "User is not verified",
    RO: "Utilizatorul nu este verificat",
  },
  invalid_login_as: {
    EN: "You cannot login as this type of user",
    RO: "Nu vă puteți conecta ca acest tip de utilizator",
  },
  account_already_exists: {
    EN: "Account already exists",
    RO: "Contul există deja",
  }
} satisfies ErrorTranslations;
